import apiClient from "@/api/client";

export interface AuditLog {
  id: number;
  user_id: number | null;
  tenant_id: number | null;
  actor_email: string | null;
  actor_role: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  details: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
}

export interface ListAuditParams {
  tenant_id?: number;
  action_prefix?: string;
  limit?: number;
  offset?: number;
}

export async function listAuditLogs(
  params: ListAuditParams = {},
): Promise<AuditLog[]> {
  const { data } = await apiClient.get<AuditLog[]>("/admin/audit", { params });
  return data;
}
